import { useSplitIOTreatment, splitioConstants } from 'src/components/SplitIO';

export const useIsPasswordlessCheckoutEnabled = ({ skipPasswordless = false } = {}) => {
  const { splitTreatment } = useSplitIOTreatment(
    splitioConstants.SPLITIONAME_PASSWORDLESS_CHECKOUT,
  );
  if (skipPasswordless) return false;
  return [splitioConstants.ON, splitioConstants.CONTROL].includes(splitTreatment);
};
